import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '../components/Dashboard';
import Popups from '../components/Popups';
import ManageNotification from '../components/ManageNotification';
import HomepagePromotions from '../components/HomepagePromotions';
import HomepageServices from '../components/HomepageServices';
import AddHomepageServices from '../components/AddHomepageServices';
import EditHomepageServices from '../components/EditHomepageServices';
import AddHomepagePromotion from '../components/AddPromotions';
import AddNewsEvents from '../components/AddNewsEvents';
import HomepageNewsEvents from '../components/HomepageNewsEvents';
import EditPromotions from '../components/EditPromotions';
import EditNewsEvents from '../components/EditNewsEvents'
import AddPopups from '../components/AddPopups'
import Announcements from '../components/Announcements'
import AddAnnouncements from '../components/AddAnnouncements'
import EditAnnouncements from '../components/EditAnnouncements'
import EditPopups from '../components/EditPopups'
import Messages from '../components/Messages'
import EditMessages from '../components/EditMessages'
import AddMessages from '../components/AddMessages'
import AddVideos from '../components/AddVideos'
import Videos from '../components/Videos'
import EditVideos from '../components/EditVideos'
import HomeLinks from '../components/Homelinks'
import Login from '../components/Login'
import ManageHomepageSections from '../components/ManageHomePageSections'
import EditHomepageSection from '../components/EditHomepageSection'
import ManageAppVersion from '../components/ManageAppVersion'
import EditAppVersion from '../components/EditAppVersion'
import LOFandExpiry from '../components/LOFandExpiry'
import AddLOFandExpiry from '../components/AddLOFandExpiry'
import FreshWorks from '../components/FreshWorks'
import PackageIDs from '../components/PackageIDs'

Vue.use(Router);

export default new Router({
  routes:
    [
      {
        path: '/my/login',
        component: Login
      },
      {
        path: '/my/popups',
        name: 'Popup',
        component: Popups
      },
      {
        path: '/my/popups/create',
        name: 'AddPopups',
        component: AddPopups
      },
      {
        path: '/my/links',
        name: 'HomeLinks',
        component: HomeLinks
      },
      {
        path: '/my/notification',
        name: 'SubscribeNotification',
        component: ManageNotification
      },
      {
        path: '/my/homepage/sections',
        name: 'HomepageSections',
        component: ManageHomepageSections
      },
      {
        path: '/my/homepage/sections/edit/:itemId',
        name: 'EditHomepageSection',
        component: EditHomepageSection
      },
      {
        path: '/my/dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: '/my/homepage/promotions',
        name: 'HomepagePromotions',
        component: HomepagePromotions
      },
      {
        path: '/my/homepage/promotions/add',
        name: 'AddHomepagePromotions',
        component: AddHomepagePromotion
      },
      {
        path: '/my/homepage/promotions/edit/:itemId',
        name: 'EditHomepagePromotions',
        component: EditPromotions
      },
      {
        path: '/my/homepage/services',
        name: 'HomepageServices',
        component: HomepageServices
      },
      {
        path: '/my/homepage/services/add',
        name: 'AddHomepageServices',
        component: AddHomepageServices
      },
      {
        path: '/my/homepage/services/edit/:itemId',
        name: 'EditHomepageServices',
        component: EditHomepageServices
      },
      {
        path: '/my/homepage/news-events',
        name: 'HomepageNewsEvents',
        component: HomepageNewsEvents,
      },
      {
        path: '/my/homepage/news-events/add',
        name: 'AddHomepageNewsEvents',
        component: AddNewsEvents
      },
      {
        path: '/my/homepage/news-events/edit/:itemId',
        name: 'EditHomepageNewsEvents',
        component: EditNewsEvents
      },
      {
        path: '/my/announcements',
        name: 'Announcements',
        component: Announcements,
      },
      {
        path: '/my/announcements/create',
        name: 'AddAnnouncements',
        component: AddAnnouncements,
      },
      {
        path: '/my/announcements/edit/:itemId',
        name: 'EditAnnouncements',
        component: EditAnnouncements,
      },
      {
        path: '/my/popups/edit/:itemId',
        name: 'EditPopups',
        component: EditPopups,
      },
      {
        path: '/my/messages',
        name: 'Messages',
        component: Messages,
      },
      {
        path: '/my/messages/create',
        name: 'AddMessages',
        component: AddMessages,
      },
      {
        path: '/my/messages/edit/:itemId',
        name: 'EditMessages',
        component: EditMessages,
      },
      {
        path: '/my/videos',
        name: 'Videos',
        component: Videos
      },
      {
        path: '/my/videos/add',
        name: 'AddVideos',
        component: AddVideos
      },
      {
        path: '/my/homepage/videos/edit/:itemId',
        name: 'EditVideos',
        component: EditVideos
      },
      {
        path: '/my/homepage/appversion',
        name: 'ManageAppVersion',
        component: ManageAppVersion
      },
      {
        path: '/my/homepage/appversion/edit/:itemId',
        name: 'EditAppVersion',
        component: EditAppVersion
      },
      {
        path: '/my/homepage/lofandexpiry',
        name: 'LOFandExpiry',
        component: LOFandExpiry
      },
      {
        path: '/my/homepage/lofandexpiry/add',
        name: 'AddLOFandExpiry',
        component: AddLOFandExpiry
      },
      {
        path: "/freshworks/",
        name: "FreshWorks",
        component: FreshWorks
      },
      {
        path: "/my/packageids/",
        name: "PackageIDs",
        component: PackageIDs
      }
    ],
  scrollBehavior()
  {
    return { x: 0, y: 0 }
  },
  mode: 'history'
});